<template>
  <div class="is-overlay spinner-overlay">
    <load-spinner v-if="$store.state.user.isLoggedIn === ''"></load-spinner>

    <div class="login-needed" v-if="$store.state.user.isLoggedIn === 0">
      <div class="notification">
        <!-- <button class="delete"></button> -->
        חלה שגיאה בטעינת הנתונים שלך, אנא נסה להתחבר שוב.
        <br />
        <strong>לחץ\י על הכפתור להמשך</strong>
        <br />
        <a
          href="https://yoganow.co.il/?&service=logout"
          class="yoga-btn-purple"
        >
          המשך
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LoadSpinner from "@/components/LoadSpinner.vue";

export default {
  components: {
    LoadSpinner,
  },
};
</script>

<style lang="scss">
$overlayBg: rgba(101, 107, 133, 0.9);

.spinner-overlay {
  background-color: $overlayBg;
  padding: 15px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.login-needed {
  .notification {
    background-color: #dedede;
    .yoga-btn-purple {
      text-decoration: none;
      font-size: 18px;
      font-weight: bold;
      margin-top: 10px;
    }
  }
}
</style>
